<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { getKZColumn, getValue } from "@/DataHelper";
import {
  AufgabeStatusContainer,
  getKZAufgabeDefiniton,
} from "./ChartTypesAndFunctions";
import { goBack } from "@/NavigationHelper";
import DashboardChartsListe from "@/components/dashboard/Charts/Liste.vue";
import DashboardChartsTabelle from "@/components/dashboard/Charts/Tabelle.vue";
import DashboardChartsKalender from "@/components/dashboard/Charts/Kalender.vue";
import DashboardChartsCChart from "@/components/dashboard/Charts/CChart.vue";
import DashboardChartsQuickInfo from "@/components/dashboard/Charts/QuickInfo.vue";
import DashboardChartsKpi from "@/components/dashboard/Charts/KPI.vue";
let props = defineProps<{
  waitingForQVAics: boolean;
  as: AufgabeStatusContainer;

  QuickViewMode?: boolean;
  persoenlich?: boolean;
  QvAICs?: number[];
  AllQvAics?: number[];
  aic?: number;
}>();
const emit = defineEmits<{
  hideAufgabeTitle: any;
  hideDialogTitel: any; // is das nicht dasselbe wie aufgabetitel ?
  dashboardItemTitle: [title?: string];
  vectorChanged: number[];
  buildFilter: any;
  aicsLoaded: number[];
}>();
let showTitle = ref<boolean>(false);
let vector = ref<number[]>();

function quickViewAicsLoaded(...aics: number[]) {
  emit("aicsLoaded", ...aics);
}
onMounted(() => {
  if (props.as.params.aicStamm && props.as.params.aufgabenDefinition) {
    showTitle.value = !getKZAufgabeDefiniton(
      "hideTitelStatus",
      props.as.params.aicStamm,
      props.as.params.aufgabenDefinition,
      showTitle,
    );
  }
  if (props.as.status.darstellungKennung === "KPI") {
    showTitle.value = false;
    emit("hideAufgabeTitle");
  }
  if (!showTitle) {
    emit("dashboardItemTitle", props.as.titel);
  }
});
</script>
<template>
  <v-container style="display: inline-block">
    <v-toolbar-title v-if="showTitle">{{ as.titel }}</v-toolbar-title>
    <DashboardChartsQuickInfo
      v-if="props.as.status.darstellungKennung == 'QuickView'"
      :params="props.as.params"
      @aicsLoaded="quickViewAicsLoaded"
      :QvAICs="props.QvAICs"
      @vectorChanged="emit('vectorChanged', (vector = $event))"
      @buildFilter="emit('buildFilter', $event)"
      :persoenlich="props.persoenlich"
    />
    <DashboardChartsKpi
      v-if="
        props.as.status.darstellungKennung == 'KPI' && !props.waitingForQVAics
      "
      :params="props.as.params"
      :QvAICs="props.QvAICs"
      :QuickViewMode="props.QuickViewMode"
      :persoenlich="props.persoenlich"
    />
    <DashboardChartsCChart
      v-if="props.as.params.chartType && !props.waitingForQVAics"
      :params="props.as.params"
      :QvAICs="
        props.AllQvAics && props.AllQvAics.length > 0
          ? props.AllQvAics
          : props.QvAICs
      "
      :QuickViewMode="props.QuickViewMode"
      :persoenlich="props.persoenlich"
    />
    <DashboardChartsKalender
      v-if="
        props.as.status.darstellungKennung == 'Kalender' &&
        props.as.params.aufgabenDefinition &&
        !props.waitingForQVAics
      "
      :params="props.as.params"
      :QvAICs="props.QvAICs"
      :persoenlich="props.persoenlich"
    />
    <DashboardChartsListe
      v-if="
        props.as.status.darstellungKennung == 'Liste' && !props.waitingForQVAics
      "
      :params="props.as.params"
      :QvAICs="props.QvAICs"
      @back="goBack()"
      @hideDialogTitel="emit('hideDialogTitel')"
      :persoenlich="props.persoenlich"
    />
    <DashboardChartsTabelle
      v-if="
        props.as.status.darstellungKennung == 'Tabelle' &&
        !props.waitingForQVAics
      "
      :params="props.as.params"
      :QvAICs="props.QvAICs"
      :aic="props.aic"
      :persoenlich="props.persoenlich"
    />
  </v-container>
</template>
